import { ExpandCollapseIcon } from './expand-collapse-icon';

export default ExpandCollapseIcon;
